import { Link, Outlet, useLoaderData, useNavigate } from 'react-router-dom'

import type { IAccount } from '@glocal/schemas'

import { getAuth, signOut } from 'firebase/auth'

import { requireUser } from '../auth'
import { Wordmark } from '../components/wordmark'
import { firebaseApp } from '../firebase'
import { trpc } from '../trpc'

export async function loader(): Promise<{ account: IAccount }> {
	await requireUser()
	// AccountService.Me bootstraps an account on first login.
	const account = await trpc().AccountService.Me.query()
	return { account }
}

export function Root() {
	const { account } = useLoaderData() as Awaited<ReturnType<typeof loader>>
	const navigate = useNavigate()

	async function handleSignOut() {
		await signOut(getAuth(firebaseApp))
		navigate('/login')
	}

	return (
		<div className="min-h-screen bg-bone text-ink">
			<TopBar
				email={account.email}
				onSignOut={() => void handleSignOut()}
			/>
			<main className="mx-auto max-w-[1200px] px-6 py-10">
				<Outlet />
			</main>
		</div>
	)
}

function TopBar({ email, onSignOut }: { email: string; onSignOut: () => void }) {
	return (
		<header className="border-b border-line bg-bone/80 backdrop-blur sticky top-0 z-10">
			<div className="mx-auto max-w-[1200px] px-6 h-16 flex items-center justify-between">
				<Link
					to="/"
					aria-label="Go to dashboard"
					className="rounded-nayda-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-marigold focus-visible:ring-offset-2 focus-visible:ring-offset-bone"
				>
					<Wordmark className="text-[22px] hover:text-ember transition-colors" />
				</Link>
				<div className="flex items-center gap-4">
					<span className="font-mono text-[12px] text-ink-soft">{email}</span>
					<button
						onClick={onSignOut}
						className="btn btn-ghost h-9 px-3 text-[13px]"
					>
						Sign out
					</button>
				</div>
			</div>
		</header>
	)
}
